import React from 'react';
import PropTypes from 'prop-types';
import './CloseAll.css';

export default function CloseAll({ count, onClick }) {
  return (
    <button
      className="btn desktop-notification-close-all"
      onClick={onClick}
      type="button"
    >
      Clear All ({count})
    </button>
  );
}

CloseAll.propTypes = {
  count: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};

CloseAll.defaultProps = {
  count: 0
};
